export class navigationScroll {
	constructor( node ) {
		this.node = node;
		if ( ! this.node ) return;

		//this.navHeight = this.node.offsetHeight;
		//this.groupsHeight = this.calculateGroupsHeight();
		this.ticking = false;

		//this.node.style.setProperty( '--aof-masthead-height', `${ this.navHeight }px` );
		this.onScroll = this.onScroll.bind( this );
		this.onResize = this.onResize.bind( this );

		this.updateHeights();

		window.addEventListener( 'scroll', this.onScroll );
		window.addEventListener( 'resize', this.onResize );
	}

	updateHeights() {
		this.navHeight = this.node.offsetHeight;
		this.groupsHeight = this.calculateGroupsHeight();
		document.body.style.setProperty( '--aof-masthead-height', `${ this.navHeight }px` );
	}

	calculateGroupsHeight() {
		let totalHeight = 0;
		const extraGroups = document.querySelectorAll( '.masthead > .wp-block-group:not(.masthead__primary)' );
		extraGroups.forEach( ( group ) => {
			totalHeight += group.offsetHeight;
		} );
		return totalHeight;
	}

	onScroll() {
		if ( ! this.ticking ) {
			window.requestAnimationFrame( () => {
				this.handleScroll();
				this.ticking = false;
			} );
			this.ticking = true;
		}
	}

	onResize() {
		this.updateHeights();
		this.handleScroll(); // Optional: immediately re-check scroll position after resizing
	}

	handleScroll() {
		const hasScrolled = window.scrollY >= this.navHeight;
		const isScrolledClassSet = this.node.classList.contains( 'masthead--scroll' );

		if ( hasScrolled && ! isScrolledClassSet ) {
			this.node.style.transform = `translateY(-${ this.groupsHeight }px)`;
			this.node.classList.add( 'masthead--scroll' );
		} else if ( ! hasScrolled && isScrolledClassSet ) {
			this.node.style.transform = `translateY(0)`;
			this.node.classList.remove( 'masthead--scroll' );
		}
	}
}
document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.masthead' ).forEach( ( node ) => {
		new navigationScroll( node );
	} );
} );
